import { render, staticRenderFns } from "./MentionsSettings.vue?vue&type=template&id=1a11e12c"
import script from "./MentionsSettings.vue?vue&type=script&lang=js"
export * from "./MentionsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports